<template>
<div class="surveillance-explaur">
  <div v-if="!display">
    <strong><loading-text>Chargement</loading-text></strong>
  </div>
  <div v-else>
    <div class="row">
      <div class="col-xs-12">
        <h1 class="text-primary">
          <small>Programme National {{ year }}</small>
          <br>
          <span class="label label-reaExplaur">RÉA-explAUR</span>
        </h1>
        <hr>
      </div>
    </div>
    <div class="panel panel-info">
      <div class="panel-heading">
        <span v-show="display">
          <div class="form-inline">
            <div class="form-group">
              <div class="input-group">
                <input required ref="input"
                       id="input" tabindex="0"
                       class="form-control" v-model="text"
                       type="text"
                       placeholder="Chercher par établissement..."
                       autocomplete="off"/>
              </div>
              <typeahead v-model="selection"
                         open-on-focus
                         force-select
                         target="#input"
                         :data="explaurList"
                         item-key="value"/>
            </div>
            <div class="form-group">
              OU
            </div>
            <div class="form-group">
              <div class="input-group">
                <input required ref="creno"
                       id="creno" tabindex="0"
                       class="form-control" v-model="crenoText"
                       type="text"
                       placeholder="Chercher par numéro court..."
                       autocomplete="off"/>
              </div>
              <typeahead v-model="crenoNumber"
                         open-on-focus
                         force-select
                         target="#creno"
                         :data="swabList"
                         item-key="value"/>
            </div>
            <div class="form-group">
              <btn type="primary" @click="showGenerateModal()">
                Générer un document de travail
              </btn>
            </div>
          </div>
        </span>
      </div>
    </div>
    <modal v-model="generateModal"
           size="lg"
           title="Génération d'un document de travail">
      <template slot="footer">
        <btn type="primary" :disabled="gen.list.length === 0"
             @click="generate">
          Générer
        </btn>
      </template>
      <h3>Liste des écouvillons concernés</h3>
      <div v-if="gen.list.length === 0">
        <alert type="warning">
          Aucun écouvillon sélectionné.
        </alert>
      </div>
      <div v-else>
        <table class="table table-responsive">
          <thead>
            <tr>
              <th>Numéro court</th>
              <th>Établissement</th>
              <th>Label</th>
              <th>Service</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(s, k) in gen.list" :key="`gen-swab-${k}`">
              <td>
                {{ s.value }}
              </td>
              <td>
                {{ s.surveillance.establishment.name }}
              </td>
              <td>
                {{ s.label }}
              </td>
              <td>
                {{ s.uf }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="form-inline">
        <div class="form-group">
          <div class="input-group">
            <input required ref="gencreno"
                   id="gencreno" tabindex="0"
                   class="form-control" v-model="gen.crenoText"
                   type="text"
                   placeholder="Chercher par numéro court..."
                   autocomplete="off"/>
          </div>
          <typeahead v-model="gen.crenoNumber"
                     open-on-focus
                     force-select
                     target="#gencreno"
                     :data="genSwabList"
                     item-key="value"/>
        </div>
        <div class="form-group">
          <btn type="primary" @click="addSwabToGeneration"
               :disabled="gen.crenoNumber == null">
            Ajouter
          </btn>
        </div>
      </div>
    </modal>
    <div v-if="selection">
      <h3>{{ currentEstablishment }}</h3>
      <h4>
        <span class="label label-reaExplaur">RÉA-explAUR</span>
      </h4>
      <alert :type="status.alert">
        {{ status.text }}
      </alert>
      <div v-if="status.servicedest">
        <tabs>
          <tab title="Écouvillons">
            <div class="row swab-tab">
              <div v-for="u in units"
                   :key="`swab-${u.unit.name}-${u.unit.ufType}`"
                   class="col-xs-12 col-md-6">
                <div class="panel panel-reaExplaur">
                  <div class="panel-heading">
                    <div class="panel-title">
                      {{u.unit.name}} ({{u.code}})
                    </div>
                  </div>
                  <div class="panel-body">
                    <alert v-if="u.episods.length === 0"
                           type="info">
                      Aucun écouvillon préparé.
                    </alert>
                    <div v-for="(e, k) in u.episods"
                         :key="`swab-${k}-${u.unit.name}-${u.unit.ufType}`">
                      <h4>
                        <span v-if="e.creno != null">
                          {{ e.creno }} //
                        </span>
                        {{ e.label }}
                      </h4>
                      <alert :type="e.alert">
                        <h5>{{e.status}}</h5>
                        <div v-if="e.patient || e.receive">
                          <a class="btn btn-reaExplaur btn-sm"
                             v-if="e.patient"
                             @click="showPatient(u, k)">
                            Fiche patient
                          </a>
                          <a class="btn btn-warning btn-sm"
                             v-if="e.waiting"
                             @click="confirmNotifySent(u,k)">
                            Écouvillon envoyé
                          </a>
                          <a class="btn btn-warning btn-sm"
                             v-if="e.receive"
                             @click="confirmNotifyReceived(u, k)">
                            Écouvillon reçu
                          </a>
                        </div>
                      </alert>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <modal v-model="patientModal">
              <template slot="title">
                Fiche Patient
                <span class="label label-reaExplaur">
                  RÉA-explAUR
                </span>
              </template>
              <template slot="footer">
                <a class="btn btn-reaExplaur" @click="patientModal = false">
                  Ok
                </a>
              </template>
              <div v-if="target.unit && patientModal">
                <div class="row">
                  <div class="col-xs-12">
                    <div class="form-group">
                      <label class="control-label">
                        NUMÉRO DE FICHE
                      </label>
                      <input disabled
                             class="form-control"
                             :value="`${target.swab.label}`"
                             type="text"/>
                    </div>
                    <div class="form-group">
                      <label class="control-label">
                        UF/NOM DU SERVICE
                      </label>
                      <input disabled class="form-control"
                             :value="`${target.unit.unit.name} (${target.unit.code})`">
                    </div>
                  </div>
                </div>
                <sui-field-list v-model="target.swab.model"
                                :fields="patientFields" :waiting="waiting">
                </sui-field-list>
              </div>
            </modal>
          </tab>
          <tab title="Fiches Service">
            <div v-for="u in units" :key="`${u.unit.name}-${u.unit.ufType}`">
              <h3>Fiche service : {{u.unit.name}} ({{u.code}})</h3>
              <hr>
              <sui-field-list v-model="u.model" :fields="unitFields"
                              :waiting="waiting">
              </sui-field-list>
            </div>
          </tab>
          <tab title="Destinataire des écouvillons">
            <div class="row">
              <div class="col-xs-12 col-md-8 col-lg-6">
                <h3>Destinataire des écouvillons</h3>
                <table class="table table-responsive">
                  <tbody>
                    <tr>
                      <td><strong>Nom</strong></td>
                      <td>{{ dest.firstName }} {{ dest.name }}</td>
                    </tr>
                    <tr>
                      <td><strong>Fonction</strong></td>
                      <td>{{ dest.role }}</td>
                    </tr>
                    <tr>
                      <td><strong>Établissement</strong></td>
                      <td>{{ dest.establishment }}</td>
                    </tr>
                    <tr>
                      <td><strong>Service</strong></td>
                      <td>{{ dest.service }}</td>
                    </tr>
                    <tr>
                      <td><strong>Adresse</strong></td>
                      <td>{{ dest.address }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab>
        </tabs>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import impl from '@/views/surveillance/impl/explaur'
import loading from '@/sui/components/loadingtext'
import suiFieldList from '@/sui/components/fieldlist'
import { mapState, mapGetters } from 'vuex'
import units from '@/sui/data/units'
import sc from '@/sui/sc/explaur'
import { confirm } from '@/sui/tools/modal'
import moment from 'moment'

export default {
  name: 'surveillance-explaur',

  data () {
    const y = this.$route.params.year
    return {
      selection: null,
      crenoNumber: null,
      text: '',
      crenoText: '',
      formError: new Error(),
      unitFields: sc.unitFields(y),
      patientFields: sc.patientFields(y),
      waiting: true,
      explaur: null,
      details: null,
      patientModal: false,
      target: {
        unit: null,
        model: null,
        swab: -1
      },
      generateModal: false,
      gen: {
        crenoNumber: null,
        crenoText: '',
        list: []
      }
    }
  },

  mounted: function () {
    if (!this.display) {
      this.$store.dispatch('surveillances/all', this.year)
    }
  },

  watch: {
    year: function () {
      this.selection = null
      this.crenoNumber = null
      this.crenoText = ''
    },

    crenoNumber: function (v) {
      if (v != null) {
        const id = v.surveillance.id
        const sel = this.explaurList.find(
          e => {
            return e.surveillance.id === id
          }
        )
        this.selection = sel
      }
    },

    selection: function (u) {
      if (u != null) {
        this.refresh(u)
      } else {
        this.details = null
      }
    }
  },

  computed: {
    ...mapState({
    }),

    ...mapGetters({
      getListByName: 'surveillances/listByName'
    }),

    display: function () {
      return this.establishmentList != null &&
             this.establishmentList.length > 0
    },

    year: function () {
      return this.$route.params.year
    },

    establishmentList: function () {
      return this.getListByName(this.year)
    },

    explaurList: function () {
      const result = []
      this.establishmentList.forEach(
        l => {
          const s = l.surveillance
          if (s.modules.reaExplaur != null) {
            result.push(l)
          }
        }
      )
      return result
    },

    swabList: function () {
      const result = []
      const uy = units[this.year]
      this.explaurList.forEach(
        l => {
          const m = l.surveillance.modules.reaExplaur
          const f = l.surveillance.establishment.finess
          m.srvs.forEach(
            s => {
              const code = uy.findFromIndex(s.uf.ufType).code
              const uf = `${s.uf.name}\n${code}`
              s.epds.forEach(
                (e, i) => {
                  if (e.crnb > 0) {
                    result.push(
                      {
                        value: `${e.crnb}`,
                        label: `${f}-${s.labl}${i + 1}`,
                        uf: uf,
                        surveillance: l.surveillance
                      }
                    )
                  }
                }
              )
            }
          )
        }
      )
      return result
    },

    genSwabList: function () {
      return this.swabList.filter(
        s => this.gen.list.indexOf(s) === -1
      )
    },

    currentEstablishment: function () {
      if (this.selection == null) {
        return null
      }

      return this.selection.surveillance.establishment.name
    },

    selectedModule: function () {
      if (this.selection == null) {
        return null
      }

      return this.selection.surveillance.modules.reaExplaur
    },

    dest: function () {
      if (this.selection == null) {
        return null
      }

      return this.selectedModule.dest
    },

    status: function () {
      if (this.selectedModule == null) {
        return null
      }

      const st = this.selectedModule.stat.val
      const result = {
        alert: '',
        text: '',
        servicedest: false

      }

      switch (st) {
        case 0:
          result.alert = 'info'
          result.text =
            'En attente du destinataire des résultats et de la fiche service.'
          break

        case 1:
          result.alert = 'warning'
          result.text = 'Écouvillons à envoyer.'
          result.servicedest = true
          break

        case 2:
          result.alert = 'info'
          result.text = `Écouvillons envoyés à l'établissement.`
          result.servicedest = true
          break

        case 3:
          result.alert = 'info'
          result.text = `Écouvillons reçus par l'établissement.`
          result.servicedest = true
          break
      }
      return result
    },

    units: function () {
      if (this.details == null) {
        return null
      }

      const list = this.details.srvs
      const result = []
      const prefix = this.selection.surveillance.establishment.finess
      const uy = units[this.year]
      list.forEach(
        l => {
          const model = {}
          for (let k in l.prct) {
            model[k] = {
              error: '',
              value: l.prct[k]
            }
          }
          const episods = []
          for (let i = 0; i !== l.epds.length; i++) {
            const e = l.epds[i]
            const prms = {}
            for (let k in e.prms) {
              let value = e.prms[k]
              const f = this.patientFields.find(p => p.key === k)
              if (f == null) {
                continue
              }

              const op = f.options
              if (op != null && op.date) {
                value = moment(value).format('DD/MM/YYYY')
              }
              prms[k] = {
                error: '',
                value: value
              }
            }

            const episod = {
              label: `${prefix}-${l.labl}${i + 1}`,
              model: prms,
              alert: 'info',
              status: '',
              patient: e.stat > 0,
              waiting: e.stat === 1,
              receive: e.stat === 2
            }

            if (e.crnb !== 0) {
              episod.creno = e.crnb
            }

            switch (e.stat) {
              case 0:
                episod.status = 'En attente de la fiche patient...'
                break
              case 1:
                episod.status = `En attente d'envoi...`
                break
              case 2:
                episod.status = `En cours d'acheminement au laboratoire...`
                episod.alert = 'warning'
                break
              case 3:
                episod.status = `Reçu au laboratoire, en cours de traitement`
                break
            }
            episods.push(episod)
          }

          const srv = {
            code: uy.findFromIndex(l.uf.ufType).code,
            unit: l.uf,
            model: model,
            label: l.labl,
            episods: episods
          }

          result.push(srv)
        }
      )
      return result
    }
  },

  methods: {
    showGenerateModal: function () {
      this.gen.crenoNumber = null
      this.gen.crenoText = ''
      this.gen.list = []
      this.generateModal = true
    },

    addSwabToGeneration: function () {
      if (this.gen.crenoNumber == null) {
        return
      }

      this.gen.list.push(this.gen.crenoNumber)
      this.gen.crenoNumber = null
      this.gen.crenoText = ''
    },

    generate: function () {
      if (this.gen.list.length === 0) {
        return
      }

      impl.exportExplaurPDF(this.year, this.gen.list)
      this.generateModal = false
    },

    showPatient: function (u, k) {
      this.target.swab = u.episods[k]
      this.target.unit = u
      this.patientModal = true
    },

    confirmNotifySent: function (u, k) {
      const swab = `${u.label}${k + 1}`
      const name = u.unit.name
      const code = u.code
      confirm(
        this,
        `<h3>Notification d'envoi d'un écouvillon</h3>
<p class="text-justify">
  Êtes-vous sûr.e de vouloir confirmer l'envoi de l'écouvillon ${swab} issu
  du service ${name} (${code}) ?
</p>`
      ).then(() => {
        this.$nextTick(() => { this.notifySwabSent(u, k) })
      }).catch((e) => {})
    },

    notifySwabSent: function (u, k) {
      const vm = this
      const selection = this.selection
      const request = {
        id: selection.surveillance.id,
        swab: k,
        uf: u.unit,
        stat: 2,
        year: selection.surveillance.year
      }
      vm.waiting = true
      vm.$store.dispatch('surveillances/setExplaurSwabStatus', request).then(
        r => {
          vm.waiting = false
          if (r.data.err != null) {
            vm.$notify(
              {
                type: 'danger',
                title: 'Erreur !',
                duration: 0,
                content: `Une erreur s'est produite pendant la confirmation
d'envoi d'un écouvillon. Si le problème persiste, merci de contacter
l'administrateur.`
              }
            )
          } else {
            vm.$notify(
              {
                type: 'success',
                title: `Confirmation de l'envoi de l'écouvillon effectuée !`,
                duration: 0
              }
            )
            vm.refresh(selection)
          }
        }
      ).catch(
        e => {
          vm.waiting = false
          vm.$notify(
            {
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une exception s'est produite pendant la notification
d'envoi d'un écouvillon. Si le problème persiste, merci de nous contacter via le
formulaire de contact.`
            }
          )
        }
      )
    },

    confirmNotifyReceived: function (u, k) {
      const swab = `${u.episods[k].label}`
      const name = u.unit.name
      const code = u.code
      confirm(
        this,
        `<h3>Réception d'un écouvillon</h3>
<p class="text-justify">
  Êtes-vous sûr.e de vouloir notifier la réception de l'écouvillon ${swab} issu
  du service ${name} (${code}) ?
</p>`
      ).then(() => {
        this.$nextTick(() => { this.notifyReceived(u, k) })
      }).catch((e) => {})
    },

    refresh: function (u) {
      this.$store.dispatch(
        'explaur/get',
        {
          id: u.surveillance.id
        }
      ).then(
        (r) => {
          if (r.data.err == null) {
            this.details = r.data
          }

          return r
        }
      )
    },

    notifyReceived: function (u, k) {
      const vm = this
      const selection = this.selection
      const request = {
        id: selection.surveillance.id,
        swab: k,
        uf: u.unit,
        stat: 3,
        year: selection.surveillance.year
      }
      vm.waiting = true
      vm.$store.dispatch('surveillances/setExplaurSwabStatus', request).then(
        r => {
          vm.waiting = false
          if (r.data.err != null) {
            vm.$notify(
              {
                type: 'danger',
                title: 'Erreur !',
                duration: 0,
                content: `Une erreur s'est produite pendant la notification
de réception d'un écouvillon. Si le problème persiste, merci de nous contacter
via le formulaire de contact.`
              }
            )
          } else {
            vm.$notify(
              {
                type: 'success',
                title: `Écouvillon bien reçu !`,
                duration: 0
              }
            )
            vm.refresh(selection)
          }
        }
      ).catch(
        e => {
          vm.waiting = false
          vm.$notify(
            {
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une exception s'est produite pendant la notification
de réception d'un écouvillon. Si le problème persiste, merci de nous contacter
via le formulaire de contact.`
            }
          )
        }
      )
    }
  },

  components: {
    'sui-field-list': suiFieldList,
    'loading-text': loading
  }
}
</script>

<style scoped lang="less">

.swab-tab {
  margin-top: 3rem;
}

.panel {
  h5:first-child {
    margin-top: 0rem;
  }

  h5:last-child {
    margin-bottom: 0rem;
  }

  .alert:last-child {
    margin-bottom: 0rem;
  }

  .alert .btn:not(:first-child) {
    margin-left: 2rem;
  }
}

.modal {
  h3:first-child {
    margin-top: 0rem;
  }
}
</style>
